import { createSelector } from 'reselect'

const selector = state => state.historyOffersReducer

export const historyFilterSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const historyLoadMoreSelector = createSelector(
  [selector],
  ({ loadMore }) => loadMore
)

export const historyLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const historyErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const historyOffersSelector = createSelector(
  [selector],
  ({ offers }) => offers
)

export const historyNoMoreSelector = createSelector(
  [selector],
  ({ noMore }) => noMore
)

export const historySelector = createSelector(
  [selector],
  history => history
)
